import { Component } from '@angular/core';

@Component({
  selector: 'fb-expansion-panel-content',
  templateUrl: './expansion-panel-content.html',
  styleUrl: './expansion-panel-content.scss',
})
export class ExpansionPanelContent {}
